import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatStepper} from '@angular/material/stepper';
import {ActivatedRoute, Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {lastValueFrom, Subscription} from 'rxjs';
import {PropostaCotacaoService} from 'src/app/api/module/erp/services/area-logada/proposta-cotacao/proposta.cotacao.service';
import {jwtAuthService} from 'src/app/api/module/erp/services/auth/jwtAuthService';
import {PropostaExternaEnum} from 'src/app/api/module/erp/shared/enumerable/poposta-externa.enum';
import {TipoProduto_E_OperadoraComponent} from 'src/app/api/module/erp/shared/enumerable/tipo-produto.enum';
import {CompartilharDadosEntreComponentsService} from 'src/app/api/module/erp/shared/services/compartilhar-dados-entre-components.service';
import {ErrorLoggingService} from 'src/app/api/module/erp/shared/services/error-logs/error-logging.service';
import {SpinnerService} from 'src/app/api/module/erp/shared/services/spinner-service.service';
import {TabNavigationService} from 'src/app/api/module/erp/shared/services/tab-navegation/tab-navegation.service';
import {AutenticacaoPropostaService} from 'src/app/api/module/externo/services/proposta/autenticacao.proposta.service';
@Component({
  selector: 'app-proposta-associado-entidade',
  templateUrl: './proposta-associado-entidade.component.html',
  styleUrls: ['./proposta-associado-entidade.component.scss'],
})
export class PropostaAssociadoEntidadeComponent implements OnInit, OnDestroy {
  abaSelecionada: any;
  tabHabilitada: boolean = true;
  mostrarModalRefreshToken: boolean = false;
  dadosRecebidosVM: any;
  prposalId!: string;
  token!: string;
  tokenParaRevalidar!: string;
  private tempoDeIntervalo: any;
  proposalId: any;
  steps!: number;
  propostaEnum = PropostaExternaEnum;
  activeTab: string | undefined;
  private subscriptionTabNavigation!: Subscription;
  @ViewChild('stepper') stepper!: MatStepper;
  abaAtiva!: string;
  listaHistoricoProposta: any[] = [];
  heOdonto: boolean = false;
  isAnalisePagamento: boolean = false;
  logoEntidade: any;
  stepAtual: any;
  private inicializacaoConcluida = false;
  heMedSenior: boolean;

  constructor(
    private _compartilharDadosEntreComponentsService: CompartilharDadosEntreComponentsService,
    private _autenticacaoPropostaService: AutenticacaoPropostaService,
    private toastr: ToastrService,
    private router: Router,
    private _activeRoute: ActivatedRoute,
    private tabService: TabNavigationService,
    private _spinnerService: SpinnerService,
    private _sesssaoService: jwtAuthService,
    private _errorLoggingService: ErrorLoggingService,
    private _propostaCotacaoService: PropostaCotacaoService,
  ) {}

  ambienteDesenvolvimentoUrl(url: string) {
    if (!url.includes('desenv-proposta')) {
      this._autenticacaoPropostaService.sairProposta();
    }
  }

  get heColaborador(): boolean {
    return this.router.url.includes('colaborador');
  }

  ngOnDestroy() {
    if (this.subscriptionTabNavigation) {
      this.subscriptionTabNavigation.unsubscribe();
    }
  }

  async ngOnInit() {
    this.iniciarSpinner();
    try {
      this.tabService.ehColaborador = this.heColaborador;
      if (this.heColaborador && !this._sesssaoService.isUsuarioLogado()) {
        this.router.navigate(['/login']);
        this.toastr.warning('Precisa Realizar o login');
        this.pararSpinner();
        return;
      }
      this.limparCache();
      const currentUrl = this.router.url;
      this.ambienteDesenvolvimentoUrl(currentUrl);
      this.proposalId = this._activeRoute.snapshot.paramMap.get('idProposta') || '';

      // Busca os dados primeiro
      await this.receberDadosCompartilhadosLeadCadastro();

      if (this.proposalId) {
        await this.buscarDadosDaProposta(this.proposalId);
      }
      setTimeout(() => {
        // Agora temos os dados, podemos definir a aba
        this.definirAbaInicial();
      }, 2000);
    } catch (error) {
      this._errorLoggingService.logError('Erro na inicialização', error);
      this.pararSpinner();
    }
  }

  definirAbaInicial() {
    if (this.inicializacaoConcluida) {
      return; // Evita múltiplas execuções
    }

    if (this.subscriptionTabNavigation) {
      this.subscriptionTabNavigation.unsubscribe();
    }

    const stepAtual = this.dadosRecebidosVM?.[0]?.dadosBeneficiario?.step || this.stepAtual;

    if (stepAtual) {
      this.steps = stepAtual;
      this.stepAtual = stepAtual;
      this.tabService.definirAbaAtivaPorNumero(stepAtual);

      this.isAnalisePagamento = false;

      if (this.heColaborador) {
        this.definirAbaColaborador(stepAtual);
      } else {
        this.definirAbaBeneficiario(stepAtual);
      }

      this.inicializacaoConcluida = true;
    }

    this.configurarSubscription();
  }
  /**
   * Define a aba ativa para usuários COLABORADORES
   * Regras específicas para colaboradores:
   * - Steps de documento (ANALISE, RETORNO_DOCUMENTO, DOCUMENTO) vai para a Aba DOCUMENTO
   * - VIDEO_CONFERENCIA   Mantém na mesma aba
   * - RETORNO_DSvai para a  CARTA_ORIENTACAO
   * - Outros steps  => Mantém no step atual
   */
  private definirAbaColaborador(stepAtual: number) {
    const {
      ANALISE,
      RETORNO_DOCUMENTO,
      DOCUMENTO,
      VIDEO_CONFERENCIA,
      RETORNO_DS,
      CARTA_ORIENTACAO,
      PAGAMENTO,
      ANALISE_PAGAMENTO,
    } = PropostaExternaEnum;
    // GRUPO 1: Steps relacionados a documentação
    // Todos redirecionam para a aba de DOCUMENTOS
    if ([ANALISE, RETORNO_DOCUMENTO, DOCUMENTO].includes(stepAtual)) {
      this.tabService.definirAbaAtivaPorNumero(DOCUMENTO);
    }
    // GRUPO 2: Video conferência - mantém na aba específica
    else if (stepAtual === VIDEO_CONFERENCIA) {
      this.tabService.definirAbaAtivaPorNumero(VIDEO_CONFERENCIA);
    }
    // GRUPO 3: Retorno de declaração de saúde - vai para carta de orientação
    else if (stepAtual === RETORNO_DS) {
      this.tabService.definirAbaAtivaPorNumero(CARTA_ORIENTACAO);
    }
    // GRUPO 4: Pagamento redireciona para a beneficiario
    else if (stepAtual === PAGAMENTO) {
      this.tabService.definirAbaAtivaPorNumero(this.propostaEnum.BENEFICIARIO_ASSOCIADO);
    }
    // GRUPO 5: Analise Pagamento redireciona para a pagamento
    else if (stepAtual === ANALISE_PAGAMENTO) {
      this.tabService.definirAbaAtivaPorNumero(PAGAMENTO);
    }
    // CASO PADRÃO: Mantém no step atual para outros cenários
    else {
      this.tabService.definirAbaAtivaPorNumero(stepAtual);
    }
  }

  private definirAbaBeneficiario(stepAtual: number) {
    const {
      ANALISE,
      RETORNO_DOCUMENTO,
      DOCUMENTO,
      CARTA_ORIENTACAO,
      PERGUNTAS,
      TERMO,
      QUESTIONARIO,
      RETORNO_DS,
      ANALISE_PAGAMENTO,
      RETORNO_PAGAMENTO,
      PAGAMENTO,
    } = PropostaExternaEnum;
    // GRUPO 1: Steps de documentação - todos vão para aba DOCUMENTOS
    if ([ANALISE, RETORNO_DOCUMENTO, DOCUMENTO].includes(stepAtual)) {
      if ([ANALISE].includes(stepAtual)) {
        this.tabService.definirAbaAtivaPorNumero(ANALISE);
      } else {
        this.tabService.definirAbaAtivaPorNumero(DOCUMENTO);
      }
    }
    // GRUPO 2: Processo de declaração de saúde - todos vão para CARTA_ORIENTACAO
    // Inclui: Carta, Perguntas, Termo, Questionário e Retorno DS
    else if ([CARTA_ORIENTACAO, PERGUNTAS, TERMO, QUESTIONARIO, RETORNO_DS].includes(stepAtual)) {
      this.tabService.definirAbaAtivaPorNumero(CARTA_ORIENTACAO);
    }

    // GRUPO 3: Análise de pagamento ou Retorno Pagamento- aba específica com flag
    else if ([ANALISE_PAGAMENTO].includes(stepAtual)) {
      this.isAnalisePagamento = true; // Ativa flag específica
      this.tabService.definirAbaAtivaPorNumero(PAGAMENTO);
    }
    // GRUPO 3: Análise de pagamento ou Retorno Pagamento- aba específica com flag
    else if ([RETORNO_PAGAMENTO].includes(stepAtual)) {
      this.isAnalisePagamento = false; // Ativa flag específica
      this.tabService.definirAbaAtivaPorNumero(PAGAMENTO);
    }
    // CASO PADRÃO: Mantém no step atual para cenários não mapeados
    else {
      this.tabService.definirAbaAtivaPorNumero(stepAtual);
    }
  }

  private configurarSubscription() {
    this.subscriptionTabNavigation = this.tabService.activeTab$.subscribe(tab => {
      this.activeTab = tab;
      // Notificações específicas por aba
      if (tab === 'declaracaoSaude') {
        this.tabService.notificarDeclaracaoSaudeAtivada();
      }

      if (tab === 'documentos') {
        this.tabService.notificarDocumentosAtivada();
      }
      const urlAtual = this.router.url; // Obtém a URL atual

      // Verifica se a URL contém o padrão "proposta/editar/{id}"

      // Força a detecção de mudanças
      setTimeout(() => {
        if (
          urlAtual.includes('proposta/colaborador/') &&
          tab === 'declaracaoSaude' &&
          this.stepAtual == this.propostaEnum.VIDEO_CONFERENCIA
        ) {
          this.activeTab = tab;
          return;
        }
        this.pararSpinner();
        this.activeTab = tab;
      }, 0);
    });
  }

  receberDadosCompartilhadosLeadCadastro(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._compartilharDadosEntreComponentsService.obterDadosCompartilhados().subscribe(
        data => {
          this.dadosRecebidosVM = data && data;
          if (this.dadosRecebidosVM) {
            this.listaHistoricoProposta = this.dadosRecebidosVM;
            this.prposalId = this.dadosRecebidosVM[0]?.propostaExternaVM?.proposalId;
            this.logoEntidade = this.dadosRecebidosVM[0]?.dadosBeneficiario?.branchCompanyNameLogo;

            this.heMedSenior = this.dadosRecebidosVM[0].dadosBeneficiario.operatorName.toLowerCase() === 'medsenior';

            if (TipoProduto_E_OperadoraComponent.isOdonto(this.dadosRecebidosVM[0].dadosBeneficiario?.productType)) {
              this.heOdonto = true;
            }

            if (this.dadosRecebidosVM[0]?.propostaExternaVM?.token) {
              this.token = this.dadosRecebidosVM[0]?.propostaExternaVM?.token;
              sessionStorage.setItem('token', this.token);
            }

            this.verificarValidadeToken();
            resolve(this.dadosRecebidosVM);
          } else if (!this.heColaborador) {
            if (!this.router.url.includes('desenv-proposta')) {
              this.router.navigate(['/']);
              this.toastr.warning('Sessão finalizada...!');
              this.pararSpinner();
            }
          }
        },
        error => {
          reject(error);
        },
      );
    });
  }

  private verificarValidadeToken(): void {
    if (!this.heColaborador) {
      // const intervalo = 1 * 60 * 1000; //1 minuto,

      const proposalId = this._activeRoute.snapshot.paramMap.get('idProposta') || '';
      this.proposalId = proposalId;
      // Define um intervalo que roda a cada 10 minutos
      this.tempoDeIntervalo = setInterval(async () => {
        try {
          const resposta = await this._autenticacaoPropostaService.validarToken(proposalId, this.token).toPromise();
        } catch (error) {
          let token = this.token;
          this.tokenParaRevalidar = token;

          clearInterval(this.tempoDeIntervalo);
          this.mostrarModalRefreshToken = true;
          this._autenticacaoPropostaService.sairProposta();
        }
      }, 3600000); //1 hora
    }
  }

  atualizarToken(): void {
    const propostaId = this._activeRoute.snapshot.paramMap.get('idProposta') || '';
    this.proposalId = propostaId;
    this._autenticacaoPropostaService.atualizarToken(propostaId, this.token).subscribe(
      (data: any) => {
        this.token = this.tokenParaRevalidar;
        sessionStorage.setItem('token', this.token);
        //se for colaborador nao exibir esta mensagem.SO deve exibir para fazer o login

        this.verificarValidadeToken();
        this.toastr.success(data.data);
        this.mostrarModalRefreshToken = false;
      },
      (error: any) => {
        this.pararSpinner();
        this.toastr.error('Erro ao atualizar o token.');
      },
    );
  }

  navegarParaProximaAba(a?: any) {
    this.tabService.avancarParaProximaAba();
  }

  /**
   * Verifica se uma aba específica pode ser acessada
   */
  podeAcessarAba(numeroAba: number): boolean {
    const ehStepPagamento = this.stepAtual === this.propostaEnum.PAGAMENTO;
    const ehStepRetornoDocumento = this.stepAtual === this.propostaEnum.RETORNO_DOCUMENTO;
    // 🔹 Beneficiário mantém regra atual
    if (!this.dadosRecebidosVM?.[0]?.dadosBeneficiario?.step) {
      return false;
    }

    // 🔹 Colaborador no step 14 → só Beneficiário
    if (this.heColaborador && ehStepPagamento) {
      return numeroAba === PropostaExternaEnum.BENEFICIARIO_ASSOCIADO;
    }
    // 🔹 Colaborador no step 11 → só Beneficiário
    if (this.heColaborador && ehStepRetornoDocumento) {
      return numeroAba === PropostaExternaEnum.BENEFICIARIO_ASSOCIADO;
    }

    // Define o step atual no serviço
    this.tabService.definirStepAtual(this.dadosRecebidosVM[0].dadosBeneficiario.step);

    // Usa o método do serviço para verificar acesso
    return this.tabService.podeAcessarAba(numeroAba);
  }

  clicarNaAba(numeroAba: number) {
    this.iniciarSpinner();
    this.limparCache();
    // Verifica se a aba pode ser acessada
    if (!this.podeAcessarAba(numeroAba)) {
      // Se não puder acessar, mostra mensagem de erro e interrompe a navegação
      // this.toastr.info('Você precisa completar as etapas anteriores.');
      this.pararSpinner(1000);
      return;
    }

    // Define a aba como ativa
    this.tabService.definirAbaAtivaPorNumero(numeroAba);
  }

  limparCache() {
    if (window.caches) {
      // Limpa todo o cache
      caches.keys().then(names => {
        names.forEach(name => {
          caches.delete(name);
        });
      });
    }
  }

  iniciarSpinner() {
    this._spinnerService.show();
  }

  pararSpinner(ms?: number) {
    return new Promise(resolve => {
      setTimeout(() => {
        this._spinnerService.hide();
        resolve(true);
      }, ms);
    });
  }
  //Recebe Informacao do filho(app-proposta-pagamento)
  onAnalisePagamentoChange(novoEstado: boolean) {
    this.isAnalisePagamento = novoEstado;
  }

  //deixar as informacoes somente Leitura se o step for superior a 11(retorno documento) ou seja >= 12
  get ehSomenteLeituraGeral(): boolean {
    return this.tabService.obterStepAtual() >= this.propostaEnum.VIDEO_CONFERENCIA; //>=12
  }

  async buscarDadosDaProposta(propostaId: string): Promise<boolean> {
    try {
      if (!propostaId) {
        console.warn('ID da proposta não fornecido');
        return false;
      }

      const data = await lastValueFrom(this._propostaCotacaoService.buscarDadosPropostaPorId(propostaId));

      if (data) {
        this.stepAtual = data.step;
        return true;
      }

      return false;
    } catch (error) {
      this._errorLoggingService.logError('Erro ao buscar dados da proposta', error, {
        idProposta: propostaId,
      });
      this.toastr.error('Erro ao carregar dados da proposta');
      return false;
    }
  }

  // onRespostaEnvioImagem(resposta: {step: string; mensagem?: string; pessoaId?: string}) {
  //   if (resposta.step === 'erro') {
  //     this.toastr.error('Erro ao enviar imagem:', resposta.mensagem);
  //     // Tratar erro - pode mostrar modal, mudar step, etc.
  //   } else if (resposta.step === 'success') {
  //     this.toastr.success('Imagem enviada com sucesso');
  //     // Tratar sucesso
  //   }
  // }
}
